var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.9949 13.9949",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0793 6.41433H2.9156C2.27151 6.41433 1.74936 6.93647 1.74936 7.58057V11.6624C1.74936 12.3065 2.27151 12.8287 2.9156 12.8287H11.0793C11.7234 12.8287 12.2455 12.3065 12.2455 11.6624V7.58057C12.2455 6.93647 11.7234 6.41433 11.0793 6.41433Z",
    stroke: "currentColor",
    strokeWidth: 1.16624
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08185 6.41433V4.08185C4.08112 3.3588 4.34908 2.66129 4.83371 2.1247C5.31833 1.58811 5.98505 1.25074 6.70443 1.17807C7.42382 1.10541 8.14453 1.30264 8.72668 1.73147C9.30882 2.1603 9.71086 2.79014 9.85474 3.49873",
    stroke: "currentColor",
    strokeWidth: 1.16624,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.57509b1e.svg";
export { ForwardRef as ReactComponent };